module.exports = __webpack_public_path__ + "static/image/history/pc/201702.ver2_0_2.jpg?f08e06e5";